<template>
  <div class="c-nav--drawer">
    <md-toolbar class="md-large" md-elevation="0">
      <div class="md-toolbar-row">
        <md-avatar class="md-large">
          <img v-if="user.photoURL" :src="user.photoURL" alt="Avatar" />
        </md-avatar>
      </div>
      <div class="md-toolbar-row">
        <span v-if="user.displayName" class="md-title">{{ user.displayName }}</span>
      </div>
    </md-toolbar>

    <md-list>
      <div class="c-nav--user">
        <md-list-item to="/">
          <md-icon class="md-primary">dashboard</md-icon>
          <span class="md-list-item-text">{{ translate(thingsToTranslate.dashboard) }}</span>
        </md-list-item>
        <!-- <md-list-item to="calendar" v-if="isKnownUser">
            <md-icon class="md-primary">timeline</md-icon>
              <span class="md-list-item-text">Statistics</span>
            </md-list-item> -->
        <md-divider></md-divider>
      </div>
      <div class="c-nav--info">
        <md-list-item href="/about">
          <md-icon>info_outline</md-icon>
          <span class="md-list-item-text">{{ translate(thingsToTranslate.about) }}</span>
        </md-list-item>
        <md-list-item to="feedback">
          <md-icon>lightbulb_outline</md-icon>
          <span class="md-list-item-text">{{ translate(thingsToTranslate.contact) }}</span>
        </md-list-item>
        <md-list-item to="recommend">
          <md-icon>share</md-icon>
          <span class="md-list-item-text">{{ translate(thingsToTranslate.share) }}</span>
        </md-list-item>
        <md-divider></md-divider>
      </div>
      <div class="c-nav--actions">
        <md-list-item to="account">
          <md-icon>account_circle</md-icon>
          <span class="md-list-item-text">{{ translate(thingsToTranslate.account) }}</span>
        </md-list-item>
      </div>
    </md-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { translate } from "../../mixins";

export default {
  name: "Drawermenu",
  mixins: [translate],
  computed: {
    ...mapGetters(["isKnownUser"]),
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      thingsToTranslate: {
        dashboard: {
          en: "Overview",
          nl: "Overzicht"
        },
        about: {
          en: "About TRY",
          nl: "Over TRY"
        },
        contact: {
          en: "Contact",
          nl: "Contact"
        },
        share: {
          en: "Recommend",
          nl: "Delen"
        },
        account: {
          en: "Account Settings",
          nl: "Account Instellingen"
        }
      }
    };
  }
};
</script>

<style></style>
